import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { fromEvent } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ModalService {
	hasPushState = false;

	constructor(private modalService: NgbModal) {
		fromEvent(window, 'popstate').subscribe(() => {
			this.hasPushState = false;
			if (this.hasOpenModals()) {
				this.dismissAll();
			}
		});
	}

	get activeInstances() {
		return this.modalService.activeInstances;
	}
	hasOpenModals() {
		return this.modalService.hasOpenModals();
	}
	open(content: any, options?: NgbModalOptions) {
		const modal = this.modalService.open(content, options);
		this.pushState();
		this.listenToModal(modal);
		return modal;
	}
	dismissAll() {
		this.modalService.dismissAll();
	}
	private listenToModal(modal: NgbModalRef) {
		modal.result
			.then(null, () => {
				//it will call when modal is dimissed
				this.popState();
			})
			.catch(console.log);
	}
	private pushState() {
		history.pushState(null, '');
		this.hasPushState = true;
	}
	private popState() {
		if (this.hasPushState) {
			history.go(-1);
		}
		this.hasPushState = false;
	}
}
